import { render, staticRenderFns } from "./EditTeamDialog.vue?vue&type=template&id=361e9054&scoped=true&"
import script from "./EditTeamDialog.vue?vue&type=script&lang=js&"
export * from "./EditTeamDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditTeamDialog.vue?vue&type=style&index=0&id=361e9054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361e9054",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VBtn,VCardText,VForm,VIcon,VSelect,VTextField,VTextarea})
